import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'

const useAppState = () => {
    const {res} = useServerContext()

    // 1. On Server: Access via res.locals
    // 2. On Client: Access via window (checking if window exists first)
    const state =
        typeof window !== 'undefined'
            ? window.__PRELOADED_STATE__?.__STATE_MANAGEMENT_LIBRARY
            : res?.locals?.state

    return {
        preferences: state?.preferences || {},
        navigation: state?.navigation || {}
    }
}

export default useAppState
